import { RouteConfig } from 'vue-router';
import { DashboardPaths } from '@/core/constants';
import { Role } from '@/core/security/Role';
import { ApiPermissions } from '@/core/security/Permissions';

export const DashboardRoutes: RouteConfig = {
    path: DashboardPaths.Index,
    name: 'Dashboard Index',
    component: () => import('@/views/dashboard/Index.vue'),
    children: [
        {
            path: DashboardPaths.Home,
            name: 'Dashboard Home',
            component: () => import('@/views/dashboard/Home.vue'),
            meta: {
                requiresAuth: true,
                requiredRoles: [Role.Administrator]
            }
        },
        {
            path: DashboardPaths.Realm,
            name: 'Dashboard Realm',
            component: () => import('@/views/dashboard/Realm.vue'),
            meta: {
                requiresAuth: true,
                requiredRoles: [Role.Administrator],
                requiredPermissions: Object.values(ApiPermissions.Realm)
            }
        },
        {
            path: DashboardPaths.Realms,
            name: 'Dashboard Realms',
            component: () => import('@/views/dashboard/Realms.vue'),
            meta: {
                requiresAuth: true,
                requiredRoles: [Role.SuperAdmin]
            }
        },
        {
            path: DashboardPaths.Slider,
            name: 'Dashboard Slider',
            component: () => import('@/views/dashboard/Slider.vue'),
            meta: {
                requiresAuth: true,
                requiredRoles: [Role.Administrator],
                requiredPermissions: Object.values(ApiPermissions.News)
            }
        },
        {
            path: DashboardPaths.News,
            name: 'Dashboard News',
            component: () => import('@/views/dashboard/News.vue'),
            meta: {
                requiresAuth: true,
                requiredRoles: [Role.Administrator],
                requiredPermissions: Object.values(ApiPermissions.News)
            }
        },
        {
            path: DashboardPaths.Metrics,
            name: 'Dashboard Metrics',
            component: () => import('@/views/dashboard/Metrics.vue'),
            meta: {
                requiresAuth: true,
                requiredRoles: [Role.Administrator]
            }
        },
        {
            path: DashboardPaths.Users,
            name: 'Dashboard Users',
            component: () => import('@/views/dashboard/Users.vue'),
            meta: {
                requiresAuth: true,
                requiredRoles: [Role.Administrator],
                requiredPermissions: Object.values(ApiPermissions.User)
            }
        },
        {
            path: DashboardPaths.Toast,
            name: 'Dashboard Toast',
            component: () => import('@/views/dashboard/Toasts.vue'),
            meta: {
                requiresAuth: true,
                requiredRoles: [Role.Administrator],
                requiredPermissions: Object.values(ApiPermissions.Toast)
            }
        },
        {
            path: DashboardPaths.Changelog,
            name: 'Dashboard Changelog',
            component: () => import('@/views/dashboard/Changelog.vue'),
            meta: {
                requiresAuth: true,
                requiredRoles: [Role.Administrator],
                requiredPermissions: Object.values(ApiPermissions.Changelog)
            }
        },
        {
            path: DashboardPaths.Content,
            name: 'Dashboard Content',
            component: () => import('@/views/dashboard/Content.vue'),
            meta: {
                requiresAuth: true,
                requiredRoles: [Role.Administrator]
                // requiredPermissions: Object.values(ApiPermissions.Content)
            }
        },
        {
            path: DashboardPaths.LuaWorkspace,
            name: 'Dashboard LUA Workspace',
            component: () => import('@/views/dashboard/LUAWorkspace.vue'),
            meta: {
                requiresAuth: true,
                requiredRoles: [Role.Administrator],
                requiredPermissions: Object.values(ApiPermissions.Realm)
            }
        },
        {
            path: DashboardPaths.CoreWorkspace,
            name: 'Dashboard Core Workspace',
            component: () => import('@/views/dashboard/CoreScripts.vue'),
            meta: {
                requiresAuth: true,
                requiredRoles: [Role.Administrator],
                requiredPermissions: Object.values(ApiPermissions.Realm)
            }
        },
        {
            path: DashboardPaths.Modules,
            name: 'Dashboard Core Workspace',
            component: () => import('@/views/dashboard/Modules.vue'),
            meta: {
                requiresAuth: true,
                requiredRoles: [Role.Administrator],
                requiredPermissions: Object.values(ApiPermissions.Realm)
            }
        },
        {
            path: DashboardPaths.WorldServerConf,
            name: 'Dashboard Core Workspace',
            component: () => import('@/views/dashboard/WorldServerConfig.vue'),
            meta: {
                requiresAuth: true,
                requiredRoles: [Role.Administrator],
                requiredPermissions: Object.values(ApiPermissions.Realm)
            }
        }
    ]
};
